import { render, staticRenderFns } from "./ModalEditExpiredDate.vue?vue&type=template&id=d96322a6&scoped=true"
import script from "./ModalEditExpiredDate.vue?vue&type=script&lang=js"
export * from "./ModalEditExpiredDate.vue?vue&type=script&lang=js"
import style0 from "./ModalEditExpiredDate.vue?vue&type=style&index=0&id=d96322a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96322a6",
  null
  
)

export default component.exports